import React from 'react';

import { Avatar, Button, Text } from '@change/ds-core-ui/next';

import { Translate } from '@change-corgi/core/react/i18n';

import { usePetitionDetailsPageData } from 'src/app/pages/petitionGamma/details/pageContext';

import { usePetitionStarterMediaInquiry } from '../../hooks/petitionStarterMediaInquiry';
import { usePetitionStarterPhoto } from '../../hooks/petitionStarterPhoto';

import { StarterLink } from './components/StarterLink';

export function PetitionStarter(): React.JSX.Element {
	const {
		data: {
			petition: { id, organization, user },
		},
	} = usePetitionDetailsPageData();
	const { photoUrl } = usePetitionStarterPhoto();
	const {
		data: { enabled, url },
		actions: { handleMediaInquiryClick },
	} = usePetitionStarterMediaInquiry(id);
	const AVATAR_SIZE = 56;

	return (
		<div
			className="mb-4 mt-20 flex flex-nowrap items-start justify-between gap-[20px] self-stretch border-t-[1px] border-t-gray-200 pt-6 sm:mt-6 sm:flex-col sm:gap-4 md:mt-20 md:flex-row lg:flex-row"
			data-testid="petition-starters-section"
			data-qa="petition-starter-section"
		>
			<div className="flex gap-3">
				<Avatar size={AVATAR_SIZE} alt="avatar of the starter" src={photoUrl} />
				<div className="flex min-h-[80px] flex-1 flex-col items-start gap-2">
					<div className="flex flex-col">
						<StarterLink user={user} organization={organization} />
						<Text
							variant="body"
							size="medium"
							fontWeight="light"
							className="text-typography-weak mb-1"
							data-testid="petition-starter-text"
						>
							<Translate value="corgi.petition_gamma.details.starter_text" />
						</Text>
						{user.description && (
							<Text variant="body" expressive data-testid="petition-starter-description" className="leading-[28px]">
								{user.description}
							</Text>
						)}
					</div>
				</div>
			</div>

			{enabled && (
				<div className="sm:pl-[68px]">
					<Button
						as="a"
						href={url}
						variant="secondary"
						size="x-small"
						data-testid="media-inquiry"
						data-qa="media-inquiry"
						onClick={handleMediaInquiryClick}
					>
						<Translate value="corgi.petition_gamma.petition_starter.add_media_inquiries.action" />
					</Button>
				</div>
			)}
		</div>
	);
}
